import { render, staticRenderFns } from "./AddPolicy.vue?vue&type=template&id=30e92c81"
import script from "./AddPolicy.vue?vue&type=script&lang=js"
export * from "./AddPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports